import React, { useState } from 'react';
import { ChevronDown, FileText, Download, Loader2 } from 'lucide-react';
import invoiceService from '../../services/invoiceService';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount || 0);
};

const getStatusColor = (status) => {
  const colors = {
    paid: 'bg-green-100 text-green-700',
    overdue: 'bg-red-100 text-red-700',
    outstanding: 'bg-orange-100 text-orange-700',
    draft: 'bg-gray-100 text-gray-700',
    sent: 'bg-blue-100 text-blue-700',
    partial: 'bg-yellow-100 text-yellow-700'
  };
  return colors[status?.toLowerCase()] || 'bg-gray-100 text-gray-700';
};

const UnlinkedInvoices = ({ invoices, onViewInvoice }) => {
  const [expanded, setExpanded] = useState(false);
  const [downloadingId, setDownloadingId] = useState(null);

  const handleDownloadPDF = async (e, invoice) => {
    e.stopPropagation();
    setDownloadingId(invoice.id);
    try {
      await invoiceService.downloadPDF(invoice.franchisee_id, invoice.id, invoice.invoice_number);
    } catch (error) {
      console.error('PDF download failed:', error);
    } finally {
      setDownloadingId(null);
    }
  };

  if (!invoices || invoices.length === 0) return null;

  return (
    <div className="mt-6">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors w-full"
      >
        <div className="flex-1 border-t border-gray-200"></div>
        <span className="flex items-center gap-1 px-2">
          <FileText size={14} />
          QB Invoices ({invoices.length})
          <ChevronDown size={14} className={`transition-transform ${expanded ? 'rotate-180' : ''}`} />
        </span>
        <div className="flex-1 border-t border-gray-200"></div>
      </button>

      {expanded && (
        <div className="mt-3 space-y-2">
          {invoices.map(invoice => (
            <div
              key={invoice.id}
              onClick={() => onViewInvoice(invoice)}
              className="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 hover:border-pest-blue transition-all text-sm"
            >
              <div className="flex items-center gap-3">
                <FileText size={16} className="text-gray-400" />
                <div>
                  <span className="font-medium text-pest-blue">{invoice.invoice_number}</span>
                  <span className="text-gray-400 mx-2">&middot;</span>
                  <span className="text-gray-500">
                    {invoice.invoice_date ? new Date(invoice.invoice_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) : ''}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="font-medium text-gray-900">{formatCurrency(invoice.total_amount)}</span>
                <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${getStatusColor(invoice.status)}`}>
                  {invoice.status}
                </span>
                <button
                  onClick={(e) => handleDownloadPDF(e, invoice)}
                  disabled={downloadingId === invoice.id}
                  className="p-1 text-gray-400 hover:text-pest-blue disabled:opacity-50 transition-colors"
                  title="Download PDF"
                >
                  {downloadingId === invoice.id ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UnlinkedInvoices;
